import { absoluteUrl } from '@/lib/seo/site';

export const BUG_BENCH_NAME = 'Bug Bench';
export const BUG_BENCH_PATH = '/bugbench';
/** The canonical leaderboard URL, on the site origin every Bug Bench link uses. */
export const BUG_BENCH_CANONICAL_URL = absoluteUrl(BUG_BENCH_PATH);
export const BUG_BENCH_RELEASE = `${BUG_BENCH_NAME} v0.1`;
/** The day the leaderboard was first published for search engines (YYYY-MM-DD). */
export const BUG_BENCH_FIRST_PUBLISHED = '2026-07-17';
